package com.example.mystybag.core.expected

actual object NavigationHelper {
    actual fun closeScreen() {}
    actual fun setResultData(transactionRef: String?) {}
}
